// extracted by mini-css-extract-plugin
module.exports = {"header_primary":"header_primary__nRxs1","header_text":"header_text__IaHHb","square":"square__3g8SA"};